import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { useTableMode } from '@Hooks/useTableModes';
import { useCallback } from 'react';
import { containerRentTableModes, type ContainerRentTableModes } from './containerRentTableModes';
import { FrameListLatestContainerRentOrders } from './FrameListLatestContainerRentOrders';
import { FrameListUnbilledContainerRent } from './FrameListUnbilledContainerRent';

/** The unbilled rent of the standing times and the orders the user's last rent run created, one table mode each. */
// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function FrameContainerRent() {
    const hasPermission = useHasPermission();
    const canReadOrders = hasPermission(Permission.AuftragsbearbeitungOrdersRead);
    const isAvailable = useCallback(
        (mode: ContainerRentTableModes) => mode !== 'latest' || canReadOrders,
        [canReadOrders],
    );
    const tableModeProps = useTableMode<ContainerRentTableModes>('open', containerRentTableModes, isAvailable);

    return tableModeProps.tableModeValue === 'latest' ? (
        <FrameListLatestContainerRentOrders {...tableModeProps} />
    ) : (
        <FrameListUnbilledContainerRent {...tableModeProps} />
    );
}
